import { useTranslation } from "react-i18next";
import { Button, cn } from "@nexus/ui";

export type EventsView = "events" | "actions";

interface EventsViewToggleProps {
  view: EventsView;
  onViewChange: (view: EventsView) => void;
}

export function EventsViewToggle({ view, onViewChange }: EventsViewToggleProps) {
  const { t } = useTranslation();

  const options: ReadonlyArray<{ value: EventsView; label: string; hint: string }> = [
    {
      value: "actions",
      label: t("admin.events.view.actions", "Actions"),
      hint: t("admin.events.view.actionsHint", "One row per click, queue time included"),
    },
    {
      value: "events",
      label: t("admin.events.view.events", "Events"),
      hint: t("admin.events.view.eventsHint", "One row per published event"),
    },
  ];

  return (
    <div
      role="group"
      aria-label={t("admin.events.view.label", "What a row represents")}
      className="inline-flex shrink-0 rounded-sm border border-input-border bg-card p-0.5"
    >
      {options.map((option) => (
        <Button
          key={option.value}
          type="button"
          variant="ghost"
          size="sm"
          aria-pressed={view === option.value}
          title={option.hint}
          className={cn(
            "h-7 rounded-[3px] px-2.5 text-xs",
            view === option.value && "bg-primary/10 text-foreground",
          )}
          onClick={() => onViewChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
